// Whole Component Tejashwini
import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import Divider from "@mui/material/Divider";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const style = {
  position: "absolute",
  top: "55%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "320px", // Adjusted max width for compact form
  bgcolor: "background.paper",
  border: "1px",
  boxShadow: 24,
  p:3,
};



export default function SaveUser({
  userData: initialData,
  updateUser,
  roles,
  handleModelClose,handleclose,
  fetchUserData
}) { 
  const [errors, setErrors] = useState({});
  const today = new Date().toISOString().split("T")[0];
const [open, setOpen] = useState(false);
const [updatedData, setUpdatedData] = useState({});
  const [userData, setUserData] = useState({
    first_name: '',
    last_name: '',
    gender: '',
    date_of_birth: '',
    role_id: '',
    contact_no: '',
    email_id: '',
  });

  useEffect(() => {
    setUserData(initialData);
    console.log("role",roles);
  }, [initialData]);

  const handleInputChange = (e) => {
    
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validate = () => {
    let tempErrors = {};
    tempErrors.first_name = userData.first_name ? "" : "First Name is required.";
    tempErrors.last_name = userData.last_name ? "" : "Last Name is required.";
    tempErrors.gender = userData.gender ? "" : "Gender is required.";
    tempErrors.date_of_birth = userData.date_of_birth ? "" : "Date of Birth is required.";
    tempErrors.role_id = userData.role_id ? "" : "Role is required.";
    tempErrors.contact_no = userData.contact_no
      ? userData.contact_no.length < 10
        ? "Mobile No must be at least 10 digits."
        : ""
      : "Mobile No is required.";

    if (!userData.email_id) {
      tempErrors.email_id = "Email Id is required.";
    } else if (
      !userData.email_id.includes("@") ||
      !userData.email_id.includes(".") ||
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(userData.email_id)
    ) {
      tempErrors.email_id = "Please enter a valid email id";
    } else {
      tempErrors.email_id = "";
    }
    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === "");
  };

  const handleUpdate = () => {
    if (validate()) {
      updateUserData(updatedData, fetchUserData);
      updateUserData(userData);
      handleModelClose();
      
    }
  };

  const updateUserData = async (updatedData) => {
    try {
      const email = localStorage.getItem("user_email");
      if (!email) {
        setErrors({ apiError: "User email not found" });
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/updateUser`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            user_email: email,
          },
          body: JSON.stringify(updatedData),
        }
      );

      if (response.ok) {
        fetchUserData();
        const data = await response.json();
      } else {
        console.error("Failed to update user data");
      }
    } catch (error) {
      console.error("Error in update request:", error);
    }
  };

  const handleClose = () => {
    handleclose();
  }
  return (
    <Box sx={style}>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Typography
        sx={{ color: "#0A64A2", display: "flex", alignItems: "center" }}
        variant="h6"
        component="h2"
      >
        <PersonAddIcon sx={{ marginRight: 1 }} /> Edit User
      </Typography>
      <Divider style={{ background: "#0A64A2" }} />
      <Box
        component="form"
        sx={{
          paddingTop: "8px",
          alignItems: "center",
        }}
        noValidate
        autoComplete="off"
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 1,
            width: "100%",
          }}
        >
          <TextField
            id="outlined-first-name"
            label={errors.first_name || "First Name"}
            fullWidth
            required
            name="first_name"
            value={userData.first_name}
            onChange={handleInputChange}
            error={!!errors.first_name}
            size="small" // Reduced size
            margin="dense"
            sx={{ fontSize: "0.8rem" }} // Adjusted font size for compactness
            inputProps={{
              maxLength: 50,
              onInput: (e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')),
            }}
          />
          <TextField
            id="outlined-last-name"
            label={errors.last_name || "Last Name"}
            fullWidth
            required
            name="last_name"
            value={userData.last_name}
            onChange={handleInputChange}
            error={!!errors.last_name}
            size="small" // Reduced size
            margin="dense"
            sx={{ fontSize: "0.8rem" }} // Adjusted font size for compactness
            inputProps={{
              maxLength: 50,
              onInput: (e) => (e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')),
            }}
          />
          
          <FormControl
              fullWidth
              sx={{ mb: 1, pt: 0, pb: 0 }}
              error={!!errors.gender}
              size="small"
            >
              <InputLabel id="select-gender-label" required>
                Gender
              </InputLabel>
              <Select
                labelId="select-gender-label"
                id="select-gender"
                value={userData.gender}
                onChange={handleInputChange}
                label={errors.gender ? errors.gender : "Gender"}
                name="gender"
              >
                <MenuItem value="M">Male</MenuItem>
                <MenuItem value="F">Female</MenuItem>
              </Select>
            </FormControl>
          <TextField
            size="small" // Reduced size
            name="date_of_birth"
            label={errors.date_of_birth || "Date of Birth"}
            type="date"
            fullWidth
            inputProps={{ max: today }}
            InputLabelProps={{ shrink: true }}
            value={userData.date_of_birth}
            onChange={handleInputChange}
            error={!!errors.date_of_birth}
            margin="dense"
            sx={{ fontSize: "0.8rem" }} // Adjusted font size for compactness
          />
          <TextField
            id="outlined-role-id"
            select // This makes the TextField a dropdown menu
            label={errors.role_id || "Select Role"}
            fullWidth 
            required
            name="role_id"
            value={userData.role_id || ""}
            onChange={handleInputChange}
            error={!!errors.role_id}
            size="small" // Reduced size
            margin="dense"
            disabled
            sx={{ fontSize: "0.8rem" }}
          >
            {roles.map((role) => (
              <MenuItem key={role.role_id} value={role.role_id}>
                {role.role_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            type="number"
            id="outlined-mobile-number"
            label={errors.contact_no || "Contact Number"}
            fullWidth
            required
            name="contact_no"
            value={userData.contact_no}
            onChange={handleInputChange}
            error={!!errors.contact_no}
            size="small" // Reduced size
            margin="dense"
            inputProps={{
              maxLength: 10,
              onInput: (e) => {
                if (e.target.value.length > 10) {
                  e.target.value = e.target.value.slice(0, 10);
                }
              },
            }}
            sx={{ fontSize: "0.8rem" }} // Adjusted font size for compactness
          />
          <TextField
            id="outlined-email-id"
            label={errors.email_id || "Email ID"}
            fullWidth
            required
            name="email_id"
            value={userData.email_id}
            onChange={handleInputChange}
            error={!!errors.email_id}
            size="small" // Reduced size
            margin="dense"
            sx={{ fontSize: "0.8rem" }} // Adjusted font size for compactness
          />
         <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" onClick={handleUpdate} sx={{ mt: 2 }}>
                Update
            </Button>
          </div>
        </Box>
      </Box>
    </Box>
  );
}
